module.exports = __webpack_public_path__ + "static/img/btn_logo_nor@2x.ea0bf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_logo_nor@2x.png
// module id = b0O6
// module chunks = 1